import { useMemo } from "react";
import classNames from "classnames";
import PiCreatorDropdown from "./PiCreatorDropdown";
import PiCreatorDropdownItem from "./PiCreatorDropdownItem";

export default function PiCreatorStringDropdown(props: {
  selectedItem: string;
  items: string[] | undefined;
  label?: string;
  onClick: (item: string) => void;
  triggerClassName?: string;
  textClassName?: string;
  dropdownClassName?: string;
  /** Trigger look; sequence nodes use "square". */
  dropdownStyle?: "small" | "square";
}) {
  const dropdownItems = (props.items ?? []).map((item) => (
    <PiCreatorDropdownItem
      key={item}
      text={item}
      onClick={() => props.onClick(item)}
    />
  ));

  const trigger = useMemo(
    () => (
      <div
        className={classNames(
          "flex items-center w-full h-full px-[12px] gap-[10px] text-creator-text-sub text-[20px]",
          props.triggerClassName
        )}
      >
        <div
          className={classNames(
            "my-auto font-normal truncate text-[12px]",
            props.textClassName
          )}
        >
          {props.selectedItem ?? "None"}
        </div>
      </div>
    ),
    [props.selectedItem, props.textClassName, props.triggerClassName]
  );

  return (
    <div className={props.dropdownClassName}>
      <PiCreatorDropdown
        style={props.dropdownStyle ?? "small"}
        label={props.label}
        trigger={trigger}
        items={dropdownItems}
      />
    </div>
  );
}
